import type Transition from '@ember/routing/transition';
import type RouterService from '@ember/routing/router-service';

/** Validates that routes have a proper `sortBy` value - if they don't, the
 *  route is reloaded with default query params reset.
 *  This mitigates an issue that can occur with query param bleed when switching
 *  between top-level routes while a query is in progress, leading to an invalid
 *  name in the `sortBy` query param.
 */
export function validateSortBy(
  route: { router: RouterService; routeName: string },
  transition: Transition,
  validSortBy: string[],
): void {
  const { sortBy } = (transition.to?.queryParams ?? {}) as Record<
    string,
    string
  >;
  if (sortBy && !validSortBy.includes(sortBy)) {
    route.router.replaceWith(route.routeName, {
      queryParams: { sortBy: '', sortDir: '', before: '', after: '' },
    });
  }
}
